import { render, staticRenderFns } from "./DesktopEventIcon.vue?vue&type=template&id=781cf3a0"
import script from "./DesktopEventIcon.vue?vue&type=script&lang=js"
export * from "./DesktopEventIcon.vue?vue&type=script&lang=js"
import style0 from "./DesktopEventIcon.vue?vue&type=style&index=0&id=781cf3a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports